export const OTHER_CANCEL_REASON = 'Other'

export const CANCEL_REASONS = [
  'Duplicate Invoice',
  'Wrong Patient',
  'Wrong Service',
  'Wrong Payer',
  'Wrong Amount',
  'Registration Error',
  'Insurance Eligibility Issue',
  'Service not provided',
  OTHER_CANCEL_REASON
]
